import { CommonPost } from "../../../../utils/CommonFetch";

export default {
    getReportData
};

async function getReportData(data) {
    var model = {
        fromDate: data.fromDate,
        toDate: data.toDate,
    };
    const response = await CommonPost('/api/DailyAttendanceDownload/GetDailyAttendanceDownloadReport', null, model);
    return response.data;
}



